import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Box, HStack, VStack, Pressable, Text } from "native-base";
import Svg from "react-native-svg";
import { CommonTabs } from "../../../components/tabs";
import { COLORS } from "../../../utils/colors";
import Logo from "../../../utils/logo";
import { activeEventTab, activePackagesTab } from "../../../store/reducers/eventSlice";
import {
  NotificationList,
  SendNotification,
} from "../webHeader/modalChildren/notification";
import { Logout } from "../webHeader/logout";
import BackButton from "../../../components/backButton";
import { Link } from "react-router-dom";
import { redirectToCMS } from "../../../utils/cmsRedirect";
import { logoutSVG } from "../../../utils/svg";
import { hasPermission } from "../../../utils/permission";
import { getUserInformations } from "../../../api/apis/login";
import { getNotificationAPI } from "../../../api/apis/notification";
import { Redirect } from "react-router-dom";

const MobileHeader = ({
  showTabs = false,
  updateDataTabChange = () => {},
  quicklink = "",
}) => {
  const dispatch = useDispatch();
  const activeTab = useSelector((state) => {
    return state.event.activeTab;
  });
  const [activeEvent, setActiveEvent] = useState(activeTab);
  const tabs = [
    { key: "mice", title: "MICE", show: true },
    { key: "event", title: "Event", show: true },
    { key: "packages", title: "Packages", show: hasPermission("PACKAGES_TAB") },
    { key: "meet", title: "Quick Meet", show: hasPermission("QUICK_MEET") }
  ];
  const [notificationData, setNotificationData] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const [info, setInfo] = useState(null);
  useEffect(() => {
    getNotification();
    getUserInformations().then((res) => {
      setInfo(res.data.data.data);
    });
  }, []);

  const getFormattedDate = (dates) => {
    const reformattedDateString = dates.replace(
      /(\d{2})-(\d{2})-(\d{4}) (\d{2}:\d{2}:\d{2})/,
      "$3-$2-$1T$4"
    );
    const originalDate = new Date(reformattedDateString);
    originalDate.setHours(originalDate.getHours() + 5);
    originalDate.setMinutes(originalDate.getMinutes() + 30);
    const formattedDate = new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "short",
      year: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).format(originalDate);

    return formattedDate;
  };

  async function getNotification() {
    let notifiy = await getNotificationAPI();
    if (notifiy?.data?.data?.data) {
      let notify = [],
        count = 0;
      Object.keys(notifiy.data.data.data).length > 0 &&
        notifiy.data.data.data["notifications data"].map((item) => {
          notify.push({
            id: item._id,
            event_id: item.event_id,
            image: item.image,
            video: item.video,
            description: item.description,
            datetime: getFormattedDate(item.datetime),
            status: item.read,
            package_id: item.package_id,
            type: item.notification_type,
            mis: item?.mis
          });
          count = !item.read ? count + 1 : count;
        });
      if (notifiy.data.data.data.unread_count) {
        setUnreadCount(notifiy.data.data.data.unread_count);
      }
      setNotificationData(notify);
    }
  }

  const header = () => {
    return (
      <Box flexDirection="row" justifyContent="space-between" pb={2}>
        <HStack>
          {window.location.pathname !== "/home" && (
            <Link
              to={
                window.location.pathname === "/event-detail/photo-detail" ||
                window.location.pathname === "/event-detail/all-photo-detail" ||
                window.location.pathname ===
                  "/event-detail/all-review-detail" ||
                window.location.pathname === "/event-detail/new-review-detail"
                  ? "/event-detail"
                  : "/home"
              }
            >
              <BackButton size={"lg"} />
            </Link>
          )}
          <Logo w={158} h={45} />
        </HStack>
        <HStack mt={3} space={2}>
          {(hasPermission("ADMIN") || info?.role === 'initiator') && (
            <Pressable onPress={() => redirectToCMS()}>
              <HStack alignItems="center" space={1} bg={COLORS.WHITE_COLOR} px={2} py={1} borderRadius="md">
                <Svg width="20" height="20" viewBox="0 0 24 28">
                  {logoutSVG}
                </Svg>
                <Text color="#FF0000" fontSize="xs" fontWeight="medium">
                  App CMS
                </Text>
              </HStack>
            </Pressable>
          )}
          {hasPermission("SEND_NOTIFICATION") && <SendNotification />}
          <NotificationList
            notificationData={notificationData}
            unreadCount={unreadCount}
            getNotification={getNotification}
          />
          <Logout />
        </HStack>
      </Box>
    );
  };

  if (shouldRedirect) {
    quicklink === "yes" && dispatch(activeEventTab(activeEvent));
    return <Redirect to="/home" />;
  }
  

  const setActiveButton = (key) => {
    updateDataTabChange();
    dispatch(activeEventTab(key));
    dispatch(activePackagesTab("New request"));
    setActiveEvent(key);
    if ((key === "packages" || key === "meet") && quicklink === "yes") {
      setShouldRedirect(true);
    }
  };

  return (
    <VStack
      bg={COLORS.WHITE_COLOR}
      alignItems={"center"}
      justifyContent={"center"}
    >
      <Box mt="3" w={"93%"}>
        {header()}
      </Box>
      {showTabs && (
        <Box pt={5}>
          <CommonTabs
            tabs={tabs}
            activeButton={activeEvent}
            setActiveButton={setActiveButton}
          />
        </Box>
      )}
    </VStack>
  );
};

export default MobileHeader;
